'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PersistentMediaPlayerCTA = require('./PersistentMediaPlayerCTA');

var _PersistentMediaPlayerCTA2 = _interopRequireDefault(_PersistentMediaPlayerCTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PersistentMediaPlayerCTA2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PersistentMediaPlayerCTA/index.js
// module id = 630
// module chunks = 11